<template>
    <div >
        <van-popup v-model="showPopup" position="center" :close-on-click-overlay="false">
            <div class="agree_content">
                <div class="title">
                    {{ extend_id ? ' 审核未通过原因' : '评论违规' }}
                </div>
                <div class="xiyibox">
                    {{ reason }}
                </div>
                <div class="btn">
                    <template v-if="extend_id">
                        <div class="btn-group">
                            <single-button text='我已知晓' width="5.9rem" height="1.7rem" background="transparent"
                                color="#8E8E8E" border="0.05rem solid #8E8E8E" @know='doClose' class="btn1" />
                            <single-button text='重新发布' width="5.9rem" height="1.7rem" color="#FFDB89" @know="doAgree"
                                class="btn2" />
                        </div>
                    </template>
                    <template v-else>
                        <single-button text='我已知晓' width="5.9rem" height="1.7rem" color="#FFDB89" @know='doClose' />
                    </template>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    props: {
        reason: {
            type: String,
            default: ''
        },
        extend_id: {
            type: [String, Number],
            default: ''
        },
        game_id: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            showPopup: false
        };
    },
    mounted() {
    },
    methods: {
        doOpen() {
            this.showPopup = true;
        },

        doClose() {
            this.showPopup = false;
        },
        doAgree() {
            this.doClose()
            this.$router.push({
                path: '/pages/community/pages/publish',
                query: {
                    game_id: this.game_id,
                    extend_id: this.extend_id
                }
            });
        }
    },

}
</script>

<style lang="scss" scoped>
.van-popup {
    border-radius: 0.5rem;
}
.agree_content {
    width: 15.5rem;
    padding: 0 0.7rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: linear-gradient(180deg, #FFF3D4 0%, #FFFFFF 40%);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;

    .title {
        font-weight: bold;
        color: #000000;
        padding-top: 1.55rem;
        font-size: 1rem;
    }

    .xiyibox {
        padding: 1rem 0;
    }

    .btn {
        width: 17rem;
        padding: 0 1rem;
        padding-bottom: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn2 {
            margin-left: 1.15rem !important;
        }

        .btn-group {
            display: flex;
            align-items: center;
        }
    }

    .img {
        position: absolute;
        display: block;
        width: 0.925rem;
        height: 0.925rem;
        bottom: -3rem;
    }
}
</style>